import { addQueryArgs } from '@wordpress/url'
import mkReduxActionApiRequest from 'scripts/util/redux/mkReduxActionApiRequest'

export const LOAD_ESTATES = 'ksk001/estateOverview/LOAD_ESTATES'
export const LOAD_ESTATES_SUCCESS = 'ksk001/estateOverview/LOAD_ESTATES_SUCCESS'
export const LOAD_ESTATES_FAILURE = 'ksk001/estateOverview/LOAD_ESTATES_FAILURE'
export const LOAD_ESTATES_ABORTED = 'ksk001/estateOverview/LOAD_ESTATES_ABORTED'

export const initialState = {
  abortController: null,
  data: [],
  page: 1,
  totalPosts: null,
  totalPages: null,
  error: null,
  isLoading: false,
  singleEstateLink: null,
}

export default (state = initialState, action) => {
  const { abortController, payload, type } = action

  switch (type) {
    case LOAD_ESTATES:
      return {
        ...state,
        isLoading: true,
        abortController,
      }
    case LOAD_ESTATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        abortController: null,
        data: payload.data,
        totalPosts: payload.totalPosts,
        totalPages: payload.totalPages,
        page: payload.page,
        singleEstateLink: payload.singleEstateLink,
      }
    case LOAD_ESTATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        abortController: null,
        error: payload.error,
      }
    case LOAD_ESTATES_ABORTED:
      return {
        ...state,
        isLoading: false,
        abortController: null,
      }
    default:
      return state
  }
}

let lastFilters = null
let lastPage = null
let lastOnlyCount = null

export const loadEstates = (page = 1, onlyCount = false) => (
  dispatch,
  getState
) => {
  const {
    estateOverviewFilters: filters,
    estateOverview: { abortController: previousAbortController },
  } = getState()

  // make sure we don't load the same data twice
  if (
    (lastFilters === filters &&
      lastPage === page &&
      lastOnlyCount === onlyCount) ||
    (lastOnlyCount === false && onlyCount === true) ||
    (filters.location && !filters.location.lat)
  ) {
    return
  }
  lastFilters = filters
  lastPage = page
  lastOnlyCount = onlyCount

  const queryParams = {
    page,
    ...filters,
    onlyCount,
  }

  return mkReduxActionApiRequest({
    apiFetchArgs: {
      path: addQueryArgs('/dhsv/v1/estate/overview', queryParams),
    },
    types: {
      initial: LOAD_ESTATES,
      success: LOAD_ESTATES_SUCCESS,
      failure: LOAD_ESTATES_FAILURE,
      aborted: LOAD_ESTATES_ABORTED,
    },
    dispatch,
    previousAbortController,
  })
}
